const isDev = process.env.NODE_ENV === "development";
export const ifDev = <T>(dev: T) => (isDev ? dev : null);
